module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/fukidashi_yellow-00d48fb812404868456a492a026c94c9.svg";